export default function R_Syntax_Print() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">R_Syntax_Print Component</h1>
      <p>This is the R_Syntax_Print tutorial section.</p>
    </div>
  );
}
